import { Reducer } from 'redux'
import { ActionTypes, ROUTE_ACTIONS, User, Account, Notification, FeatureMatrix } from './types'
import { PATHS } from '~/biz/routes/paths'
import { COUNTRY } from '~/managers/ConfigManager'

import { BUSINESS_VERIFICATION_STATUS, PERSONAL_VERIFICATION_STATUS } from '~/types'

const initialState = {
  currentRedirect: null,
  isInitiated: false,
  user: {
    kcId: undefined,
    merchantId: '',
    fullName: '',
    email: '',
    mobileNumber: '',
    companyId: '',
    userRole: undefined,
    displayname: '',
    avatarUrl: '',
  },
  accounts: [],
  notifications: {
    data: [],
    unreadCount: 0,
    isLoading: false,
  },
  featureMatrix: {
    userRole: null,
    country: COUNTRY.SINGAPORE,
    availableWallets: [],
    businessVerificationStatus: BUSINESS_VERIFICATION_STATUS.INITIAL,
    personalVerificationStatus: PERSONAL_VERIFICATION_STATUS.INITIAL,
    availableFundPools: [],
    companyTxnVolume: -1,
    isIdentificationDone: false,
    isHighRiskMerchant: false,
  },
}

type State = {
  isInitiated: boolean
  currentRedirect: PATHS | null
  user: User
  accounts: Account[]
  notifications: {
    data: Notification[]
    unreadCount: number
    isLoading: boolean
  }
  featureMatrix: FeatureMatrix
}

export const route: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case ROUTE_ACTIONS.SET_REDIRECT: {
      return {
        ...state,
        currentRedirect: action.to,
      }
    }
    case ROUTE_ACTIONS.SET_USER_PROFILE: {
      return {
        ...state,
        user: {
          ...action.user,
        },
      }
    }
    case ROUTE_ACTIONS.UPDATE_USER_PROFILE: {
      return {
        ...state,
        user: {
          ...state.user,
          avatarUrl: action.avatarUrl,
        },
      }
    }
    case ROUTE_ACTIONS.SET_TRANSACTION_ACCOUNTS: {
      return {
        ...state,
        accounts: action.accounts,
      }
    }
    case ROUTE_ACTIONS.SET_NOTIFICATIONS: {
      const { data, unreadCount, isLoading } = action
      return {
        ...state,
        notifications: {
          ...state.notifications,
          data,
          unreadCount,
          isLoading,
        },
      }
    }
    case ROUTE_ACTIONS.TOGGLE_NOTIFICATIONS_LOADING: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isLoading: action.isLoading,
        },
      }
    }
    case ROUTE_ACTIONS.SET_FEATURE_MATRIX: {
      return {
        ...state,
        featureMatrix: {
          ...action.featureMatrix,
        },
      }
    }
    case ROUTE_ACTIONS.INITIATE_GLOBAL_STORE: {
      return {
        ...state,
        isInitiated: true,
      }
    }
    case ROUTE_ACTIONS.INVALIDATE_GLOBAL_STORE: {
      return {
        ...state,
        isInitiated: false,
      }
    }
    case ROUTE_ACTIONS.SET_HIGH_RISK_MERCHANT: {
      const { isHighRiskMerchant } = action
      return {
        ...state,
        featureMatrix: {
          ...state.featureMatrix,
          isHighRiskMerchant,
        },
      }
    }
    default:
      return state
  }
}
